import { Project } from '../models/project.model';

export const mapToProject = (raw: any): Project => ({
  projectId: raw.projectId,
  projectName: raw.projectName,
  organizationId: raw.organizationId,
  organizationName: raw.organizationName,
  insights: raw.insights || [],
  metaAccountId: raw.metaAccountId || '',
  deleted: raw.deleted ?? false,
  createdAt: raw.createdAt,
  updatedAt: raw.updatedAt,
  active: raw.active ?? false,
});

export const mapToProjects = (data: any): Project[] => {
  // Handle case where data might be nested under 'projects' key
  const rawItems = data?.projects || data;
  
  if (!Array.isArray(rawItems)) {
    return [];
  }
  
  return rawItems.map(mapToProject);
};